import Head from 'next/head';
import { Box, Container, Table, TableBody, TableCell, TableHead, TableRow, Typography, Grid, Card } from '@mui/material';
import { DashboardLayout } from '../components/dashboard-layout';
import { useAuth } from '../contexts/AuthContext';

const items1H = [
  {"weight": "2 Kg - 10 L",	    "2km": "5.50 €",   	"km+": "1.10 €"},
  {"weight": "4 Kg - 20 L",	    "2km": "6.05 €",   	"km+": "1.15 €"},
  {"weight": "6 Kg - 30 L",	    "2km": "6.60 €",   	"km+": "1.21 €"},
  {"weight": "8 Kg - 40 L",	    "2km": "7.15 €",   	"km+": "1.26 €"},
  {"weight": "10 Kg - 50 L",	  "2km": "7.70 €",   	"km+": "1.32 €"},
  {"weight": "20 Kg - 100 L",	  "2km": "11.00 €", 	"km+": "1.59 €"},
  {"weight": "30 Kg - 150 L",	  "2km": "13.75 €", 	"km+": "1.87 €"},
  {"weight": "40 Kg - 200 L",	  "2km": "16.50 €", 	"km+": "2.09 €"},
  {"weight": "50 Kg - 250 L",	  "2km": "19.25 €", 	"km+": "2.31 €"},
  {"weight": "60 Kg - 300 L",	  "2km": "22.00 €", 	"km+": "2.42 €"},
  {"weight": "70 Kg - 350 L",	  "2km": "24.75 €", 	"km+": "2.53 €"},
  {"weight": "80 Kg - 400 L",	  "2km": "27.50 €", 	"km+": "2.64 €"},
  {"weight": "90 Kg - 450 L",	  "2km": "30.25 €", 	"km+": "2.75 €"},
]

const items2H = [
  {"weight": "2 Kg - 10 L",    "2km":	"5.27 €",   "km+":	"1.05 €"},
  {"weight": "4 Kg - 20 L",   "2km":	"5.79 €",   "km+":	"1.10 €"},
  {"weight": "6 Kg - 30 L",   "2km":	"6.31 €",   "km+":	"1.16 €"},
  {"weight": "8 Kg - 40 L",   "2km":	"6.83 €",   "km+":	"1.21 €"},
  {"weight": "10 Kg - 50 L",  "2km":	"7.35 €",   "km+":	"1.26 €"},
  {"weight": "20 Kg - 100 L",  "2km":	"10.45 €",   "km+":	"1.55 €"},
  {"weight": "30 Kg - 150 L", "2km":	"13.05 €",  "km+":	"1.79 €"},
  {"weight": "40 Kg - 200 L", "2km":	"15.65 €",  "km+":	"2.02 €"},
  {"weight": "50 Kg - 250 L", "2km":	"18.25 €",  "km+":	"2.21 €"},
  {"weight": "60 Kg - 300 L", "2km":	"20.85 €",  "km+":	"2.31 €"},
  {"weight": "70 Kg - 350 L", "2km":	"23.45 €",  "km+":	"2.42 €"},
  {"weight": "80 Kg - 400 L", "2km":	"26.05 €",  "km+":	"2.52 €"},
  {"weight": "90 Kg - 450 L", "2km":	"28.65 €",  "km+":	"2.63 €"},
]

const items3H = [
  {"weight": "2 Kg - 10 L",    "2km":	"4.95 €",   "km+":	"1.00 €"},
  {"weight": "4 Kg - 20 L",   "2km":	"5.45 €",   "km+":	"1.05 €"},
  {"weight": "6 Kg - 30 L",   "2km":	"5.95 €",   "km+":	"1.10 €"},
  {"weight": "8 Kg - 40 L",   "2km":	"6.45 €",   "km+":	"1.15 €"},
  {"weight": "10 Kg - 50 L",  "2km":	"6.95 €",   "km+":	"1.20 €"},
  {"weight": "20 Kg - 100 L",  "2km":	"9.90 €",   "km+":	"1.50 €"},
  {"weight": "30 Kg - 150 L", "2km":	"12.35 €",  "km+":	"1.70 €"},
  {"weight": "40 Kg - 200 L", "2km":	"14.80 €",  "km+":	"1.95 €"},
  {"weight": "50 Kg - 250 L", "2km":	"17.25 €",  "km+":	"2.10 €"},
  {"weight": "60 Kg - 300 L", "2km":	"19.70 €",  "km+":	"2.20 €"},
  {"weight": "70 Kg - 350 L", "2km":	"22.15 €",  "km+":	"2.30 €"},
  {"weight": "80 Kg - 400 L", "2km":	"24.60 €",  "km+":	"2.40 €"},
  {"weight": "90 Kg - 450 L", "2km":	"27.05 €",  "km+":	"2.50 €"},
]

const items1H_HUB = [
  {"weight": "2 Kg - 10 L",    "Paris": "7.70 €", "Limitrophes": "11.00 €"},
  {"weight": "4 Kg - 20 L",    "Paris": "8.35 €", "Limitrophes": "11.80 €"},
  {"weight": "6 Kg - 30 L",    "Paris": "9.02 €", "Limitrophes": "12.65 €"},
  {"weight": "8 Kg - 40 L",    "Paris": "9.67 €", "Limitrophes": "13.45 €"},
  {"weight": "10 Kg - 50 L",   "Paris": "10.34 €", "Limitrophes": "14.30 €"},
  {"weight": "20 Kg - 100 L",  "Paris": "14.18 €", "Limitrophes": "18.95 €"},
  {"weight": "30 Kg - 150 L",  "Paris": "17.49 €", "Limitrophes": "23.10 €"},
  {"weight": "40 Kg - 200 L",  "Paris": "20.68 €", "Limitrophes": "26.95 €"},
  {"weight": "50 Kg - 250 L",  "Paris": "23.87 €", "Limitrophes": "30.80 €"},
  {"weight": "60 Kg - 300 L",  "Paris": "26.84 €", "Limitrophes": "34.10 €"},
  {"weight": "70 Kg - 350 L",  "Paris": "29.81 €", "Limitrophes": "37.40 €"},
  {"weight": "80 Kg - 400 L",  "Paris": "32.78 €", "Limitrophes": "40.70 €"},
  {"weight": "90 Kg - 450 L",  "Paris": "35.75 €", "Limitrophes": "44.00 €"},
]

const items2H_HUB = [
  {"weight": "2 Kg - 10 L",    "Paris": "7.37 €", "Limitrophes":  "10.52 €"},
  {"weight": "4 Kg - 20 L",    "Paris": "8.00 €", "Limitrophes":  "11.30 €"},
  {"weight": "6 Kg - 30 L",    "Paris": "8.62 €", "Limitrophes":  "12.09 €"},
  {"weight": "8 Kg - 40 L",    "Paris": "9.25 €", "Limitrophes":  "12.87 €"},
  {"weight": "10 Kg - 50 L",   "Paris": "9.87 €", "Limitrophes":  "13.65 €"},
  {"weight": "20 Kg - 100 L",  "Paris": "13.55 €", "Limitrophes": "18.20 €"},
  {"weight": "30 Kg - 150 L",  "Paris": "16.62 €", "Limitrophes": "21.98 €"},
  {"weight": "40 Kg - 200 L",  "Paris": "19.69 €", "Limitrophes": "25.75 €"},
  {"weight": "50 Kg - 250 L",  "Paris": "22.66 €", "Limitrophes": "29.28 €"},
  {"weight": "60 Kg - 300 L",  "Paris": "25.47 €", "Limitrophes": "32.40 €"},
  {"weight": "70 Kg - 350 L",  "Paris": "28.28 €", "Limitrophes": "35.53 €"},
  {"weight": "80 Kg - 400 L",  "Paris": "31.09 €", "Limitrophes": "38.65 €"},
  {"weight": "90 Kg - 450 L",  "Paris": "33.90 €", "Limitrophes": "41.78 €"},
]

const items3H_HUB = [
  {"weight": "2 Kg - 10 L",    "Paris": "6.95 €", "Limitrophes": "9.95 €"},
  {"weight": "4 Kg - 20 L",    "Paris": "7.55 €", "Limitrophes": "10.70 €"},
  {"weight": "6 Kg - 30 L",    "Paris": "8.15 €", "Limitrophes": "11.45 €"},
  {"weight": "8 Kg - 40 L",    "Paris": "8.75 €", "Limitrophes": "12.20 €"},
  {"weight": "10 Kg - 50 L",   "Paris": "9.35 €", "Limitrophes": "12.95 €"},
  {"weight": "20 Kg - 100 L",  "Paris": "12.90 €", "Limitrophes": "17.40 €"},
  {"weight": "30 Kg - 150 L",  "Paris": "15.75 €", "Limitrophes": "20.85 €"},
  {"weight": "40 Kg - 200 L",  "Paris": "18.70 €", "Limitrophes": "24.55 €"},
  {"weight": "50 Kg - 250 L",  "Paris": "21.45 €", "Limitrophes": "27.75 €"},
  {"weight": "60 Kg - 300 L",  "Paris": "24.10 €", "Limitrophes": "30.70 €"},
  {"weight": "70 Kg - 350 L",  "Paris": "26.75 €", "Limitrophes": "33.65 €"},
  {"weight": "80 Kg - 400 L",  "Paris": "29.40 €", "Limitrophes": "36.60 €"},
  {"weight": "90 Kg - 450 L",  "Paris": "32.05 €", "Limitrophes": "39.55 €"},
]

// (tb + (tp*W)) + (ab + (ap*W)) * (D-2)

const pricing2024B = {
  twoKmPriceBase : 5.0,
  twoKmPriceExtraPerKg : 0.245,
  addKmPriceBase : 1.60,
  addKmPriceExtraPerKg : 0.01,
  littersPerKg : 5,
  hubDiscount: 0.18,
  hubZone1AvgKm: 4,
  hubZone2AvgKm: 7,
  twoHourCoeff:1.1,
  oneHourCoeff:1.2,

  weights : [2,4,6,8].concat(Array.from({length: 50}, (_, k) => 10*(k+1))),
}

function computePricingArray(nbHours, isHub, pricingMode) {
  if(!pricingMode.includes("2024b")) {
    if(isHub) {
      if(nbHours == 1) {
        return items1H_HUB;
      }
      if(nbHours == 2) {
        return items2H_HUB;
      }
      if(nbHours == 3) {
        return items3H_HUB;
      }      
    } else {
      if(nbHours == 1) {
        return items1H;
      }
      if(nbHours == 2) {
        return items2H;
      }
      if(nbHours == 3) {
        return items3H;
      }
    }
  } else {
    let ret = []
    for(let weight of pricing2024B.weights) {
      if(weight > 90) {
        break;
      }
      const volume = weight * 5;
      let twoKmPrice = pricing2024B.twoKmPriceBase + pricing2024B.twoKmPriceExtraPerKg * weight;
      let addKmPrice = pricing2024B.addKmPriceBase + pricing2024B.addKmPriceExtraPerKg * weight;

      if(nbHours == 2) {
        twoKmPrice = twoKmPrice * pricing2024B.twoHourCoeff;  
        addKmPrice = addKmPrice * pricing2024B.twoHourCoeff;  
      } else if(nbHours == 1) {
        twoKmPrice = twoKmPrice * pricing2024B.oneHourCoeff;  
        addKmPrice = addKmPrice * pricing2024B.oneHourCoeff;
      }

      if(isHub) {
        const parisPrice = twoKmPrice + 2 * addKmPrice;
        const limitPrice = twoKmPrice + 5 * addKmPrice;

        ret.push(
          { "weight": `${weight} Kg - ${volume} L`,	"Paris": `${parisPrice.toFixed(2)} €`, "Limitrophes": `${limitPrice.toFixed(2)} €` },
        );
      } else {
        ret.push(
          { "weight": `${weight} Kg - ${volume} L`,	"2km": `${twoKmPrice.toFixed(2)} €`, "km+": `${addKmPrice.toFixed(2)} €` },
        );
      }
    }

    return ret;
  }

}

const attributes = {
  "Poids - Volume" : "weight",
  "Forfait 2km" : "2km",
  "Km additionnel" : "km+"
}

const attributesHub = {
  "Poids - Volume" : "weight",
  "Forfait Paris" : "Paris",
  "Forfait Limitrophes" : "Limitrophes"
}

const RatesGrid = ({items, attributes}) => (
    <Card>
      <Table>
        <TableHead>
          <TableRow>
            {
              Object.entries(attributes).map(([col, field], idx) => <TableCell 
                key={col} align={idx===0 ? "left" : "right"} padding={"normal"} 
              >
                {col}
              </TableCell>)
            }                
          </TableRow>
        </TableHead>
        <TableBody>
          {items.map((item) => 
            <TableRow hover key={item.id}>
            {
              Object.entries(attributes).map(([col, field], idx) => <TableCell 
                key={col} align={idx===0 ? "left" : "right"}  padding={"normal"} sx={idx===0 ? {fontWeight: "medium" } : {}}
              > 
                {item[field]}
              </TableCell>)
            }
            </TableRow>
          )}
        </TableBody>
      </Table>
    </Card>
);

const Rates = () => {
  const { retailerId, retailerData } = useAuth();
  let actualItems1H = computePricingArray(1, false, retailerData.pricingMode??"");
  let actualItems2H = computePricingArray(2, false, retailerData.pricingMode??"");
  let actualItems3H = computePricingArray(3, false, retailerData.pricingMode??"");

  let actualItems1H_HUB = computePricingArray(1, true, retailerData.pricingMode??"");
  let actualItems2H_HUB = computePricingArray(2, true, retailerData.pricingMode??"");
  let actualItems3H_HUB = computePricingArray(3, true, retailerData.pricingMode??"");

  return (
  <>
    <Head>
      <title>
        Rates
      </title>
    </Head>
    <Box
      component="main"
      sx={{
        display: 'flex',
        justifyContent: 'center',
        mt : 3,
        mb : 3
      }}
    >
      <Container maxWidth="xl">
        <Typography sx={{ m: 3, textAlign:'center'}} variant="h4">
          Ship from Store {(retailerData.pricingMode && !retailerData.pricingMode.includes("2024a"))?"(hors options)":""}
        </Typography>        
        <Grid container spacing={8} wrap="wrap">          
          <Grid item lg={4} md={6} sm={12} sx={{ display: 'flex', flexDirection: 'column'}}>
            <Typography sx={{ my: 2, textAlign:'center'}} variant="h6">
              Créneaux 3H
            </Typography> 
            <RatesGrid items={actualItems3H} attributes={attributes} />
          </Grid>
          <Grid item lg={4} md={6} sm={12} sx={{ display: 'flex', flexDirection: 'column'}}>
            <Typography sx={{ my: 2, textAlign:'center'}} variant="h6">
              Créneaux 2H
            </Typography> 
            <RatesGrid items={actualItems2H} attributes={attributes} />
          </Grid>          
          <Grid item lg={4} md={6} sm={12} sx={{ display: 'flex', flexDirection: 'column'}}>
            <Typography sx={{ my: 2, textAlign:'center'}} variant="h6">
              Créneaux 1H
            </Typography>
            <RatesGrid items={actualItems1H} attributes={attributes} />
          </Grid>
        </Grid>
      </Container>
    </Box>
    <Box
      component="main"
      sx={{
        display: 'flex',
        justifyContent: 'center',
        mt : 3,
        mb : 3
      }}
    >
      <Container maxWidth="xl">
        <Typography sx={{ m: 3,  textAlign:'center'}} variant="h4">
          Ship from Hub {(retailerData.pricingMode && !retailerData.pricingMode.includes("2024a"))?"(hors options)":""}
        </Typography>        
        <Grid container spacing={8} wrap="wrap">          
          <Grid item lg={4} md={6} sm={12} sx={{ display: 'flex', flexDirection: 'column'}}>
            <Typography sx={{ my: 2, textAlign:'center'}} variant="h6">
              Créneaux 3H
            </Typography> 
            <RatesGrid items={actualItems3H_HUB} attributes={attributesHub} />
          </Grid>
          <Grid item lg={4} md={6} sm={12} sx={{ display: 'flex', flexDirection: 'column'}}>
            <Typography sx={{ my: 2, textAlign:'center'}} variant="h6">
              Créneaux 2H
            </Typography> 
            <RatesGrid items={actualItems2H_HUB} attributes={attributesHub} />
          </Grid>          
          <Grid item lg={4} md={6} sm={12} sx={{ display: 'flex', flexDirection: 'column'}}>
            <Typography sx={{ my: 2, textAlign:'center'}} variant="h6">
              Créneaux 1H
            </Typography>
            <RatesGrid items={actualItems1H_HUB} attributes={attributesHub} />
          </Grid>
        </Grid>
      </Container>
    </Box>
  </>
)};

Rates.getLayout = (page) => (
  <DashboardLayout>
    {page}
  </DashboardLayout>
);

export default Rates;
